export default {
  env: 'prod',
  apiBaseUrl: 'https://api.crossbeam.com',
  salesEdgeBaseUrl: 'https://sales-backend-api.crossbeam.com',
  salesEdgeRedirectUrl: 'https://sales.crossbeam.com',
  salesforceReauthUrl: 'lightning/n/xbeamprod__Setup',
  host: 'app.crossbeam.com',
  appcuesEnabled: true,
  auth0: {
    domain: 'auth.crossbeam.com',
    clientID: 'T8XLE1YbNDeGKSw9WrCYpdjLiB2dwZV4',
    audience: 'https://api.getcrossbeam.com',
  },
  statuspageBaseUrl: 'https://status.crossbeam.com',
  statuspagePageId: 'ngfln6n04fyr',
  statusPageEmbedUrl: 'https://ngfln6n04fyr.statuspage.io/embed/script.js',
  postHog: 'phc_D1NNPT8Oxcwjmud1AD9N29ZwbfniwlJ0RVRJDtOursw',
  dash0: {
    serviceName: 'crossbeam-web',
    environment: 'prod',
    endpoint: {
      url: 'https://ingress.us-west-2.aws.dash0.com',
      authToken: 'auth_Ck5azlwd0VudwBbEm54AsdKsGPvTqdoC',
    },
    propagators: [
      {
        type: 'traceparent',
        match: [/^https:\/\/api\.crossbeam\.com/],
      },
    ],
  },
  enableGoogleAnalytics: true,
  enableGoogleTags: true,
  googleTagManagerId: 'GTM-KH27GL64',
  intercom: {
    enabled: true,
    workspaceId: 'ugh1893t',
  },
  userLeap: {
    enabled: true,
    appId: 'v3tI1wOKH0t',
  },
  iteratively: {
    environment: 'production',
  },
  hubSpotForms: {
    contactSalesForm: '28accbe8-9751-4799-aef3-db69d5854f10',
    envID: '4716094',
  },
  chargify: {
    publicKey: 'chjs_dnb659f7tv76ngmkdzqqszjc',
    serverHost: 'https://crossbeam.chargify.com',
  },
  liveRampTagId: '713256',
  agentBaseUrl: 'https://agent.crossbeam.com',
  aiChatHost: 'agent.crossbeam.com',
  logoDevPublicKey: 'pk_TUuGrsTVQLOWir1pqJ6H7A',
} as const;
